<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <projectMenu :project="project" :boardId="boardId"></projectMenu>
        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="(error, key) in $page.props.errors" :key="key">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>
          <div class="text-end mb-3">
            <ProjectsHistory :project="project" :model="'CostHistory'"></ProjectsHistory>
          </div>
          <div class="card-body">
            <div class="row mt-3">
              <div class="col-12" v-if="costsData">
                <h4>Koszty</h4>
                <div v-if="isLoading">
                  <div class="position-absolute w-100 h-100 text-center" style="z-index: 9">
                    <div class="spinner-border text-danger me-2 align-self-center loader-lg" style="top:20%"></div>
                  </div>
                </div>
                <div :style="{ opacity: isLoading ? '0.4' : '1' }">
                  <ejs-grid id="GridCosts" ref="gridCosts" :key="costsGridKey" gridLines="Both" height="100%" class="top-margin"
                    :cellEdit="beforeCostsCellEdit"
                    :keyPressed="onKeyDown"
                    :dataSource="costsData"
                    :editSettings="editSettings"
                    :allowPaging="true"
                    :pageSettings="pageSettings"
                    :allowSorting="true"
                    :allowFiltering="true"
                    :filterSettings="filterOptions"
                    :toolbar="toolbar"
                    :allowReordering="true"
                    :allowResizing="true"
                    :showColumnChooser="true"
                    :selectionSettings="selectionOptions"
                    :allowSelection="true"
                    :enablePersistence="true"
                    :actionComplete="actionCostsComplete"
                    :cellSave="onCostsCellSave"
                    :toolbarClick="toolbarCostsClickE"
                    :batchCancel="onCancelCostsAction"
                    :dataBound="dataBound"
                    :queryCellInfo="costsQueryCellInfo">
                    <e-columns>
                      <e-column field="lp" headerText="L.p." width="80" type="number" :allowEditing="false" :allowSorting="true" format="N0"></e-column>
                      <e-column field="id" headerText="ID" width="85" :visible="false" :allowEditing="false" isPrimaryKey="true"></e-column>
                      <e-column field="number" headerText="Numer" type="string"></e-column>
                      <e-column field="quantity" headerText="Ilość" type="number" format="N2"></e-column>
                      <e-column field="description" headerText="Opis" type="string"></e-column>
                      <e-column field="supplier" headerText="Dostawca" type="string"></e-column>
                      <e-column field="price" headerText="Cena" type="number" format="N2"></e-column>
                      <e-column field="currency" headerText="Waluta" type="string" editType="dropdownedit" :edit="currencyParams"></e-column>
                      <e-column field="price_item_pln" headerText="Cena netto PLN" type="number" editType="numericedit" :edit="priceParams" format="N2"></e-column>
                      <e-column field="total" headerText="Wartość" :allowEditing="false" type="number" format="N2"></e-column>
                      <e-column field="total_pln" headerText="Wartość PLN" :allowEditing="false" type="number" format="N2"></e-column>
                      <e-column field="order" headerText="Zamówienie" type="string"></e-column>
                      <e-column field="team" headerText="Zespół" type="string"></e-column>
                      <e-column field="category" autocomplete headerText="Kategoria" type="string"></e-column>
                      <e-column field="created_by_name" headerText="Stworzył" :allowEditing="false" type="string"></e-column>
                    </e-columns>
                  </ejs-grid>
                  <div class="card border-0 shadow-sm mt-3">
                    <div class="card-body py-3">
                      <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Podsumowanie kosztów</h5>
                        <h4 class="mb-0 fw-bold">{{ formatPLN(totalCostsPLN) }} PLN</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 mb-2">
                <ProjectsHistory :project="project" :model="'BudgetHistory'"></ProjectsHistory>
              </div>
              <div class="col-sm-12 col-md-6" v-if="budgetData">
                <h4>Przeznaczony budżet</h4>
                <div v-if="isLoadingBudget">
                  <div class="position-absolute w-100 h-100 text-center" style="z-index: 9">
                    <div class="spinner-border text-danger me-2 align-self-center loader-lg" style="top:20%"></div>
                  </div>
                </div>
                <div :style="{ opacity: isLoadingBudget ? '0.4' : '1' }">
                  <ejs-grid id="GridBudgetProject" ref="gridBudget" :key="budgetProjectGridKey" gridLines="Both"
                    class="top-margin"
                    height="200px"
                    :keyPressed="onKeyDownBudget"
                    :dataSource="budgetData"
                    :editSettings="editSettings"
                    :allowPaging="true"
                    :pageSettings="pageSettings"
                    :allowSorting="true"
                    :allowFiltering="true"
                    :filterSettings="filterOptions"
                    :toolbar="toolbar"
                    :allowReordering="true"
                    :allowResizing="true"
                    :showColumnChooser="true"
                    :selectionSettings="selectionOptions"
                    :allowSelection="true"
                    :enablePersistence="true"
                    :actionComplete="actionBudgetComplete"
                    :dataBound="dataBound"
                    :cellSave="onBudgetCellSave"
                    :toolbarClick="toolbarBudgetClickE"
                    :batchCancel="onCancelBudgetAction"
                    :queryCellInfo="budgetQueryCellInfo">
                    <e-columns>
                      <e-column type="number" field="id" width="80" :allowEditing="false" isPrimaryKey="true" format="N0"></e-column>
                      <e-column field="budget" headerText="Budżet" type="number" format="N2"></e-column>
                      <e-column field="category" autocomplete headerText="Kategoria" type="string"></e-column>
                      <e-column field="created_by_name" headerText="Stworzył" :allowEditing="false" type="string"></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <h4>Koszty łącznie dla kategorii</h4>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Koszt</th>
                      <th>Kategoria</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(category, key) in overallCosts" :key="key">
                      <td class="text-end">{{ formatPLN(category.costs) }} PLN</td>
                      <td>{{ category.category || '(bez kategorii)' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-12 col-md-3">
                <h4>Koszty łącznie dla zespołów</h4>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Koszt</th>
                      <th>Zespół</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(team, key) in overallCosts2" :key="key">
                      <td class="text-end">{{ formatPLN(team.costs) }} PLN</td>
                      <td>{{ team.team || '(bez zespołu)' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-5">
              <h4>Podsumowanie</h4>
            </div>
            <GraphProjectBudgetsCosts :budgetData="budgetData" :overallCosts="overallCosts"></GraphProjectBudgetsCosts>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import projectMenu from "@/Pages/Projects/parts/projectMenu.vue";
import ProjectsHistory from "@/Pages/Projects/Histories/ProjectsHistory.vue";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar
} from '@syncfusion/ej2-vue-grids';
import { MultiSelect } from '@syncfusion/ej2-vue-dropdowns';
import GraphProjectBudgetsCosts from "@/Pages/Projects/Components/graphs/GraphProjectBudgetsCosts.vue";

export default {
  components: {
    GraphProjectBudgetsCosts,
    ProjectsHistory,
    AppLayout,
    projectMenu,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },
  props: {
    project: Object,
    boardId: Number,
    users: Object,
    costs: Object,
    budget: Object,
    currencys: Object
  },
  setup(page) {
    let costsData = page.costs.map((item, index) => ({
      ...item,
      lp: index + 1
    }));
    if (costsData.length === 0) {
      costsData.push({});
    }
    return {
      costsData
    };
  },
  data() {
    let overallCosts = this.calculateOverallCosts();
    let overallCosts2 = this.calculateOverallCosts2();
    return {
      isLoading: false,
      isLoadingBudget: false,
      budgetData: this.budget,
      overallCosts,
      overallCosts2,
      costsGridKey: 0,
      budgetProjectGridKey: 0,
      pageSettings: this.getPageSettings(),
      filterOptions: this.getFilterOptions(),
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      selectionOptions: this.getSelectionOptions(),
      currencyParams: this.getCurrencyParams(),
      priceParams: {
        params: {
          decimals: 2,
          value: 0,
          format: 'n2'
        }
      }
    };
  },
  computed: {
    totalCostsPLN() {
      return (this.costsData || []).reduce((sum, cost) => {
        return sum + Number(cost.total_pln || 0);
      }, 0);
    }
  },
  provide: {
    grid: [
      Page,
      Edit,
      Toolbar,
      Sort,
      Filter,
      Reorder,
      Resize,
      ColumnChooser,
      ExcelExport
    ]
  },
  methods: {
    formatNumber(value, decimals = 2) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return decimals === 0 ? '0' : '0.00';
      }
      return number.toLocaleString('pl-PL', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: true
      }).replace(/\u00A0/g, ' ');
    },
    formatPLN(value) {
      return this.formatNumber(value, 2);
    },
    formatQuantity(value) {
      return this.formatNumber(value, 2);
    },
    costsQueryCellInfo(args) {
      const numericFields = [
        'lp',
        'quantity',
        'price',
        'price_item_pln',
        'total',
        'total_pln'
      ];
      if (!numericFields.includes(args.column?.field)) {
        return;
      }
      const value = Number(args.data?.[args.column.field]);
      if (Number.isNaN(value)) {
        return;
      }
      const decimals = args.column?.field === 'lp' ? 0 : 2;
      args.cell.innerText = this.formatNumber(value, decimals);
      args.cell.style.textAlign = 'right';
    },
    budgetQueryCellInfo(args) {
      const numericFields = ['id', 'budget'];
      if (!numericFields.includes(args.column?.field)) {
        return;
      }
      const value = Number(args.data?.[args.column.field]);
      if (Number.isNaN(value)) {
        return;
      }
      const decimals = args.column?.field === 'id' ? 0 : 2;
      args.cell.innerText = this.formatNumber(value, decimals);
      args.cell.style.textAlign = 'right';
    },
    updateDeleteButtonState() {
      const grid = this.$refs.gridCosts?.ej2Instances;
      if (!grid) {
        return;
      }
      const selectedCells = grid.getSelectedRowCellIndexes();
      const hasOrderRow = selectedCells.some(cell => {
        const row = grid.currentViewData[cell.rowIndex];
        return row &&
          typeof row.id === 'string' &&
          row.id.startsWith('order_');
      });
      const deleteButton = document.querySelector('#GridCosts .e-toolbar-item#delete_btn');
      if (!deleteButton) {
        return;
      }
      deleteButton.classList.toggle('e-overlay', hasOrderRow);
      deleteButton.classList.toggle('e-disabled', hasOrderRow);
      deleteButton.style.pointerEvents = hasOrderRow ? 'none' : '';
      deleteButton.style.opacity = hasOrderRow ? '0.5' : '';
    },
    beforeCostsCellEdit(args) {
      const id = args.rowData?.id;
      if (typeof id === 'string' && id.startsWith('order_')) {
        args.cancel = true;
      }
    },
    route,
    isRouteActive(routeName) {
      return route().current() === routeName;
    },
    isOrderRowSelected() {
      const grid = this.$refs.gridCosts?.ej2Instances;
      if (!grid) {
        return false;
      }
      const selectedIndexes = grid.getSelectedRowCellIndexes();
      return selectedIndexes.some(item => {
        const row = grid.currentViewData[item.rowIndex];
        return row &&
          typeof row.id === 'string' &&
          row.id.startsWith('order_');
      });
    },
    onKeyDown(args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();
        let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
        let buttons = toolbar.querySelectorAll('.e-toolbar-item');
        let updateButton = buttons[2].querySelector('button');
        if (updateButton) {
          updateButton.click();
        }
      }
    },
    onKeyDownBudget(args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();
        let toolbar = document.getElementsByClassName('e-toolbar-left')[1];
        let buttons = toolbar.querySelectorAll('.e-toolbar-item');
        let updateButton = buttons[2].querySelector('button');
        if (updateButton) {
          updateButton.click();
        }
      }
    },
    getToolbar() {
      return [
        "Add",
        { text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn' },
        "Update",
        "Cancel",
        { text: "Search", prefixIcon: 'e-search', id: "search", align: 'center' },
        { text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
        { text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right' },
        "ColumnChooser"
      ];
    },
    deleteCostsRow() {
      let self = this;
      this.isLoading = true;
      const scrollPosition = window.scrollY;
      let gridInstance = document.getElementById('GridCosts').ej2_instances[0];
      const selectedIndexes = gridInstance.getSelectedRowCellIndexes();
      let deletedRows = selectedIndexes.map(o => gridInstance.currentViewData[o.rowIndex]);
      deletedRows = deletedRows.map(obj => obj.id);
      selectedIndexes.forEach(o => {
        gridInstance.deleteRecord('id', gridInstance.currentViewData[o.rowIndex]);
      });
      axios.delete(route('projects.show.budget.deleteCosts', {
        project: this.project,
        costs: JSON.stringify(deletedRows)
      })).then(response => {
        if (response.status === 200) {
          Toast.fire({
            position: 'top-end',
            toast: true,
            icon: response.data.icon,
            title: response.data.title,
            html: response.data.message
          });
        } else {
          Toast.fire({
            position: 'center',
            toast: false,
            icon: response.data.icon,
            title: response.data.title,
            html: response.data.message,
            timer: false,
            showCloseButton: true
          });
        }
        self.updateCostsRows();
        this.$nextTick(() => {
          window.scrollTo(0, scrollPosition);
        });
      }).catch(error => {
        console.log(error);
      });
    },
    dataBound() {
      const gridInstance = document.getElementById('GridCosts')?.ej2_instances?.[0];
      const gridInstance2 = document.getElementById('GridBudgetProject')?.ej2_instances?.[0];
      if (gridInstance) {
        gridInstance.hideScroll();
      }
      if (gridInstance2) {
        gridInstance2.hideScroll();
      }
    },
    calculateOverallCosts() {
      let overallCosts = {};
      this.costs.forEach(function(cost) {
        const category = cost.category || '';
        const value = Number(cost.total_pln || 0);
        if (overallCosts[category]) {
          overallCosts[category].costs += value;
        } else {
          overallCosts[category] = {
            category: cost.category,
            costs: value
          };
        }
      });
      Object.values(overallCosts).forEach(item => {
        item.costs = Math.round((item.costs + Number.EPSILON) * 100) / 100;
      });
      return overallCosts;
    },
    calculateOverallCosts2() {
      let overallCosts2 = {};
      this.costs.forEach(function(cost) {
        const team = cost.team || '';
        const value = Number(cost.total_pln || 0);
        if (overallCosts2[team]) {
          overallCosts2[team].costs += value;
        } else {
          overallCosts2[team] = {
            team: cost.team,
            costs: value
          };
        }
      });
      Object.values(overallCosts2).forEach(item => {
        item.costs = Math.round((item.costs + Number.EPSILON) * 100) / 100;
      });
      return overallCosts2;
    },
    onCostsCellSave(args) {
      if (args.previousValue !== args.value) {
        this.$makeDirty();
      }
    },
    onCancelCostsAction() {
      this.$makeClean();
    },
    toolbarCostsClickE(args) {
      if (args.item.id === 'delete_btn') {
        if (this.isOrderRowSelected()) {
          Toast.fire({
            toast: true,
            position: 'top-end',
            icon: 'warning',
            title: 'Nie można usunąć',
            html: 'Wybrany rekord pochodzi z zamówienia i nie może zostać usunięty.',
            timer: 2500,
            showConfirmButton: false
          });
          return false;
        }
        Toast.fire({
          toast: false,
          icon: 'warning',
          title: 'Usuwanie Wiersza',
          html: 'Na pewno chcesz usunąć wybrane wiersze?',
          showDenyButton: true,
          timer: false,
          position: 'center',
          showConfirmButton: true,
          confirmButtonText: 'Tak, usuń!',
          denyButtonText: 'Nie'
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteCostsRow();
          }
        });
        return false;
      }
      if (args.item.id === 'restore') {
        let grid = this.$refs.gridCosts;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }
      if (args.item.id === 'excelexport') {
        this.$refs.gridCosts.excelExport({
          fileName: `${this.project.number}-koszty.xlsx`
        });
      }
    },
    actionCostsComplete(args) {
      if (args.requestType === "batchsave") {
        this.isLoading = true;
        const newRows = args.rows
          .filter(row => !row.data.id || row.data.id === 0)
          .map(row => row.data);
        this.updateCostsRows(newRows);
      }
    },
    updateCostsRows(rows = []) {
      const self = this;
      axios.post(route('projects.show.budget.updateCosts', self.project.id), {
        rows: rows
      }).then(response => {
        const orderRows = this.costsData.filter(row =>
          typeof row.id === 'string' && row.id.startsWith('order_')
        );
        const costRows = response.data.map((item, index) => ({
          ...item,
          lp: index + 1
        }));
        this.costsData = [
          ...orderRows,
          ...costRows
        ];
        this.recalculateOverallCosts();
        self.isLoading = false;
        self.reloadCostsGrid();
      }).catch(error => {
        console.error('Błąd podczas aktualizacji zadań:', error.message);
        Toast.fire({
          position: 'top-end',
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: 'Błąd podczas aktualizacji zadań: ' + error.message,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
          showCloseButton: true
        });
        self.isLoading = false;
      });
    },
    recalculateOverallCosts() {
      const costs = this.costsData.filter(row => row.id || row.total_pln);
      let overallCosts = {};
      let overallCosts2 = {};
      costs.forEach(cost => {
        const category = cost.category || '';
        const team = cost.team || '';
        const value = Number(cost.total_pln || 0);
        if (overallCosts[category]) {
          overallCosts[category].costs += value;
        } else {
          overallCosts[category] = {
            category: cost.category,
            costs: value
          };
        }
        if (overallCosts2[team]) {
          overallCosts2[team].costs += value;
        } else {
          overallCosts2[team] = {
            team: cost.team,
            costs: value
          };
        }
      });
      Object.values(overallCosts).forEach(item => {
        item.costs = Math.round((item.costs + Number.EPSILON) * 100) / 100;
      });
      Object.values(overallCosts2).forEach(item => {
        item.costs = Math.round((item.costs + Number.EPSILON) * 100) / 100;
      });
      this.overallCosts = overallCosts;
      this.overallCosts2 = overallCosts2;
    },
    deleteBudgetRow() {
      let self = this;
      this.isLoadingBudget = true;
      const scrollPosition = window.scrollY;
      let gridInstance = document.getElementById('GridBudgetProject').ej2_instances[0];
      const selectedIndexes = gridInstance.getSelectedRowCellIndexes();
      let deletedRows = selectedIndexes.map(o => gridInstance.currentViewData[o.rowIndex]);
      deletedRows = deletedRows.map(obj => obj.id);
      selectedIndexes.forEach(o => {
        gridInstance.deleteRecord('id', gridInstance.currentViewData[o.rowIndex]);
      });
      axios.delete(route('projects.show.budget.deleteBudgets', {
        project: this.project,
        budgets: JSON.stringify(deletedRows)
      })).then(response => {
        if (response.status === 200) {
          Toast.fire({
            position: 'top-end',
            toast: true,
            icon: response.data.icon,
            title: response.data.title,
            html: response.data.message
          });
        } else {
          Toast.fire({
            position: 'center',
            toast: false,
            icon: response.data.icon,
            title: response.data.title,
            html: response.data.message,
            timer: false,
            showCloseButton: true
          });
        }
        self.updateBudgetRow();
        this.$nextTick(() => {
          window.scrollTo(0, scrollPosition);
        });
      }).catch(error => {
        console.log(error);
      });
    },
    actionBudgetComplete(args) {
      if (args.requestType === "batchsave") {
        this.isLoadingBudget = true;
        let newData = this.parseJsonRows(args.rows);
        this.updateBudgetRow(newData);
      }
    },
    onBudgetCellSave(args) {
      if (args.previousValue !== args.value) {
        this.$makeDirty();
      }
    },
    toolbarBudgetClickE(args) {
      if (args.item.id === 'delete_btn') {
        Toast.fire({
          toast: false,
          icon: 'warning',
          title: 'Usuwanie Wiersza',
          html: 'Na pewno chcesz usunąć wybrane wiersze?',
          showDenyButton: true,
          timer: false,
          position: 'center',
          showConfirmButton: true,
          confirmButtonText: 'Tak, usuń!',
          denyButtonText: 'Nie'
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteBudgetRow();
          }
        });
        return false;
      }
      if (args.item.id === 'restore') {
        let grid = this.$refs.gridBudget;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
        location.reload();
      }
      if (args.item.id === 'excelexport') {
        this.$refs.gridBudget.excelExport({
          fileName: `${this.project.number}-budżet.xlsx`
        });
      }
    },
    onCancelBudgetAction() {
      this.$makeClean();
    },
    updateBudgetRow(rows) {
      const self = this;
      axios.post(route('projects.show.budget.updateBudgets', self.project.id), {
        rows: rows
      }).then(response => {
        this.budgetData = response.data;
        self.isLoadingBudget = false;
        self.reloadBudgetGrid();
        self.$makeClean();
      }).catch(error => {
        console.error('Błąd podczas aktualizacji zadań:', error.message);
        Toast.fire({
          position: 'top-end',
          toast: true,
          icon: 'error',
          title: 'Błąd',
          html: 'Błąd podczas aktualizacji zadań: ' + error.message,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
          showCloseButton: true
        });
      });
    },
    parseJsonRows(rows) {
      let jsonRows = [];
      rows.forEach(function(row) {
        jsonRows.push(row.data);
      });
      return jsonRows;
    },
    reloadCostsGrid() {
      this.costsGridKey += 1;
    },
    reloadBudgetGrid() {
      this.budgetProjectGridKey += 1;
    },
    getPageSettings() {
      return {
        pageSize: 15
      };
    },
    getFilterOptions() {
      return {
        type: "Excel"
      };
    },
    getEditSettings() {
      return {
        allowEditing: true,
        allowAdding: true,
        allowDeleting: true,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch'
      };
    },
    getSelectionOptions() {
      return {
        type: 'Multiple',
        cellSelectionMode: 'Box',
        mode: 'Cell'
      };
    },
    getCurrencyParams() {
      return {
        params: {
          dataSource: this.currencys.map(currency => ({
            currency: currency.name
          })),
          fields: {
            text: 'currency',
            value: 'currency'
          }
        }
      };
    }
  }
};
</script>